/**
 * Ryan O'Dowd
 * 2022-08-11
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    container: {
      flexGrow: 1,
    },
    list: {
      flexGrow: 1,
      paddingBottom: safeAreaInsets.bottom + 4,
      paddingTop: 16,
    },
    innerContainer: {
      flexGrow: 1,
    },
    classroomsWrapper: {
      display: 'flex',
      width: '100%',
      marginBottom: 48,
      paddingHorizontal: 4,
    },
    classroomsTitleText: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
      marginBottom: globalScale * 8,
      marginLeft: globalScale * 8,
    },
    classroomListItem: {
      flex: 1,
      marginBottom: 8,
      padding: globalScale * 4,
    },
    draftOrUnassignedListItem: {
      borderColor: colors.white,
    },
    classroomName: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    schoolName: {
      fontSize: globalScale * 16,
      color: colors.accent,
    },
    teacherName: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    emptyGoalsText: {
      textAlign: 'left',
      paddingBottom: 8,
    },
    goalName: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    joinWrapperOuter: { // @TODO: abstract with fundraising
      margin: 16,
      marginTop: 24,
    },
    instructionsText: {
      display: 'flex',
      flexWrap: 'wrap',
      fontSize: globalScale * 16,
      color: colors.white,
    },
    joinWrapper: { // @TODO: abstract with fundraising
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
    textInputWrapper: {
      flex: 1,
      maxWidth: 250,
      marginRight: globalScale * 8,
    },
    titleTextInput: { // @TODO: abstract with fundraising
      display: 'flex',
      padding: 0,
      margin: 0,
    },
    messageWrapper: { // @TODO: abstract with fundraising
      display: 'flex',
      alignItems: 'center',
      marginRight: 8,
      marginLeft: 8,
    },
    joinMessage: { // @TODO: abstract with fundraising
      fontSize: globalScale * 14,
      color: colors.accentLight,
    },
    errorText: { // @TODO: abstract with fundraising
      color: colors.complete,
    },
  };
};

export default getStyles;
